var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75C3.3375 15.75 2.9845 15.6032 2.691 15.3097C2.3975 15.0162 2.2505 14.663 2.25 14.25V3.75C2.25 3.3375 2.397 2.9845 2.691 2.691C2.985 2.3975 3.338 2.2505 3.75 2.25H8.25C8.66421 2.25 9 2.58579 9 3C9 3.41421 8.66421 3.75 8.25 3.75H3.75V14.25H8.25C8.66421 14.25 9 14.5858 9 15C9 15.4142 8.66421 15.75 8.25 15.75H3.75ZM12.5439 12.2061C12.2459 12.5041 11.7607 12.4977 11.4707 12.1918C11.1913 11.8972 11.1975 11.4338 11.4846 11.1467L12.8812 9.75H6.75V8.25H12.8812L11.4846 6.85331C11.1975 6.56625 11.1913 6.10276 11.4707 5.80818C11.7607 5.50233 12.2459 5.49589 12.5439 5.79394L15.0429 8.29289C15.4334 8.68342 15.4334 9.31658 15.0429 9.70711L12.5439 12.2061Z",
    fill: "#1E1A1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ec3ac69e0b5ebaa90370b3feab9db56f.svg";
export { ForwardRef as ReactComponent };